var map = {
	"./1chaise.jpeg": "./src/assets/images/sieges/1chaise.jpeg",
	"./2chaise.jpeg": "./src/assets/images/sieges/2chaise.jpeg",
	"./3chaise.jpeg": "./src/assets/images/sieges/3chaise.jpeg",
	"./IMG_20220202_141014.jpg": "./src/assets/images/sieges/IMG_20220202_141014.jpg",
	"./IMG_20220305_091502.jpg": "./src/assets/images/sieges/IMG_20220305_091502.jpg",
	"./IMG_20220305_091703.jpg": "./src/assets/images/sieges/IMG_20220305_091703.jpg",
	"./fauteuil_studio_1930_1.jpg": "./src/assets/images/sieges/fauteuil_studio_1930_1.jpg",
	"./fauteuil_studio_1930_2.jpg": "./src/assets/images/sieges/fauteuil_studio_1930_2.jpg",
	"./fauteuil_studio_1930_3.jpg": "./src/assets/images/sieges/fauteuil_studio_1930_3.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/sieges sync \\.(jpeg%7Cpng%7CPNG%7Cphp%7CJPG%7Cjpg%7Cwebp%7Csvg)$";